import Grid from '@mui/material/Grid';
import useJobDetails from 'hooks/useJobDetails';
import Paper from 'components/system/Paper';
import JobDetailExportButton from './JobDetailExportButton';
import JobMetadata from './JobMetadata';

const jobDetailsStructure = [
  {
    label: 'Id',
    key: 'jobId',
  },
  {
    label: 'Cost',
    key: 'cost',
  },
  {
    label: 'Name',
    key: 'jobName',
  },
  {
    label: 'Created On',
    key: 'createdOn',
    tooltip: 'What time job was submitted',
  },
  {
    label: 'Status',
    key: 'runStatus',
  },
  {
    label: 'Started At',
    key: 'startedOn',
    tooltip: 'What time job started running',
  },
  {
    label: 'Device',
    key: 'device',
    tooltip: {
      quantum: 'This job was run on a quantum device',
      cpu: 'This job was simulated on a CPU',
      gpu: 'This job was simulated on a GPU',
    },
  },
  {
    label: 'Queue time',
    key: 'queueTime',
    tooltip: 'How long the job was in the queue before execution',
  },
  {
    label: 'Shots',
    key: 'shots',
  },
  {
    label: 'Run time',
    key: 'runtime',
  },
  {
    label: 'Bond dimension',
    key: 'mpsBondDimension',
  },
  {
    label: '',
    key: '',
  },
  {
    label: 'Truncation threshold',
    key: 'mpsTruncationThreshold',
  },
];

const JobDetails = (props) => {
  const {
    isLoading,
    cost,
    resultsPath,
    runStart,
    runEnd,
    createdOn,
    startedOn,
    device,
    ...job
  } = props;

  const { jobMetadataUrl, ...processedDetails } = useJobDetails({
    runStart,
    runEnd,
    cost,
    resultsPath,
    createdOn,
    startedOn,
    device,
  });

  const jobDetails = {
    ...job,
    ...processedDetails,
  };

  return (
    <Paper>
      {jobMetadataUrl && (
        <JobDetailExportButton
          onClick={jobMetadataUrl}
          buttonText="Circuit metadata"
        />
      )}
      <Grid
        container
        direction="row"
        alignItems="center"
        justifyContent="center"
      >
        <JobMetadata
          isLoading={isLoading}
          metadataStructure={jobDetailsStructure}
          metadata={jobDetails}
        />
      </Grid>
    </Paper>
  );
};

export default JobDetails;
